module.exports = __webpack_public_path__ + "img/tootha_thumb.913e2f3d.gif";